<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <h3>مقدمه</h3>
        <p class="text-end">
          صنعت عبارتست از گروهی از شرکت ها که کالاها و خدمات یکسانی تولید میکنند. جهت تحلیل کسب و کار سطح صنعت، مدل پنج نیروی رقابتی پورتر کاراترین مدل مورد استفاده سازمانها می باشد. بر اساس این مدل ، پنج عامل اصلی در فضای تجاری و رقابتی نقش دارند و بر مبنای آن می‌توان به شرایط موجود در کسب و کار پی برد و متناسب با آن استراتژی‌ها و برنامه‌های لازم را جهت مواجهه با آن تنظیم و اجرا نمود . مدل پنج نیروی رقابتی پورتر، یکی از چارچوب های شناخته شده برای تحلیل رقابت جویی است و برای توسعه استراتژی های رقابتی شرکت ها به منظور افزایش حاشیه رقابتی آن ها به کار رفته است. این مدل، پنج نیروی رقابتی – تهدیدورود رقبای جدید، قدرت چانه زنی تامین کنندگان، قدرت چانه زنی مشتریان (خریداران)، تهدید محصولات یا خدمات جایگزین، رقابت در میان شرکت های موجود در صنعت- را طرح می کند که می توانند موقعیت رقابتی یک شرکت را در یک صنعت خاص به خطر بیندازند.
        </p>
        <center>
          <img src="/img/5f.jpg" class="img-fluid rounded" style="width: 40vw" alt="">
        </center>
        <p class="text-end mt-3">
          باید توجه داشت که هرچقدر، قدرت این نیروها بیشتر باشد شرکت های کمتری می توانند در بازار رقابت ادامه دهند در نتیجه سازمان با سود بیشتری مواجه خواهد شد.علاوه بر پنج نیروی مطرح شده گروههای ذی نفع نیز مانند قدرت دولت ها و جوامع ،مشتریان و عرضه کنندگان وابسته به سازمان بخشی از تجزیه تحلیل صنعت مورد نظر می باشد.
        </p>
        <p class="text-end">
          تحلیل پنج عامل ، نقش اساسی در شناخت ضعفها و قوت ها  خواهد داشت تا در تدوین چشم‌انداز ، اهداف ، استراتژیها و برنامه‌های توسعه‌ای صنعت مورد استفاده قرار گرفته و منطبق با آن ، بتوان برنامه‌های توسعه‌ای جهت موفقیت صنعت تنظیم و به اجرا گذاشت.
        </p>
        <p class="text-end">
          درک نظریه پنج نیروی رقابتی پورتر ریشه‌های اصلی سودآوری یک صنعت را مشخص می‌کند و هم‌چنین یک قالب کلی برای پیش بینی تاثیر رقبا و تغییر میزان سود شرکت در آینده ارائه می‌دهد.
        </p>
        <hr>
        <center>
          <router-link to="/5_f/step_1" class="btn btn-primary btn-submit-1 mt-3" style="width: 7vw !important;">بعدی</router-link>
        </center>




      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  methods:{
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }
}
</script>
<style scoped lang="scss">
a{
  font-size: 1vw;
}
.card:not(:last-child){
  height: 12vw;
}
.btn-submit-1{
  width: 18vw !important;
}
/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/
p{
  font-size: 1vw;
}

</style>